import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {UserApiService} from './api/users-api.service';

@Injectable({
  providedIn: 'root',
})
export class GetServicesService {
  constructor(private userApiService: UserApiService) {}

  getMyDomains(id: number): Observable<any> {
    return this.userApiService.myDomains(id).pipe(
      map(response => {
        return response.data;
      }),
    );
  }
}
